import { useGetUserQuery } from '@/graphql';
import { useAuth } from '@agentguru/auth';
export function useMe() {
    var user = useAuth().user;
    var userId = user === null || user === void 0 ? void 0 : user['.user_id'];
    return useGetUserQuery({
        variables: {
            getUserId: userId,
        },
        skip: !userId,
    });
}
